import $ from 'jquery';
import { saveNewFormat } from './saveNewFormat';

export const onclickSaveFormatsBackground = (event) => {
  const sidebarCurrentBackgroundFormatItemId = $(event.currentTarget).data(
    'save-format-background-id'
  );
  const sidebarCurrentBackgroundFormatItemStatus = $(event.currentTarget).data(
    'save-format-background-status'
  );
  const selectedFormats = $('#formatBackgroundSelect').val();
  saveNewFormat(
    sidebarCurrentBackgroundFormatItemId,
    selectedFormats,
    sidebarCurrentBackgroundFormatItemStatus
  );
};
